<template>
  <DataTableAsync :data="items" v-model="tableState" :length="items.length" noSearch noFooter>
    <template #head>
      <tr>
        <Th prop="createdAt" sort>Created At</Th>
        <Th prop="type" sort>Type</Th>
        <Th prop="reason" sort>Reason</Th>
        <Th prop="value" sort>Value</Th>
        <Th prop="reviewedBy.email" sort>Reviewed by</Th>
        <Th prop="reviewedAt" sort>Reviewed at</Th>
        <Th prop="isApproved" sort>Response</Th>
        <Th prop="reviewReason" sort>Reason</Th>
      </tr>
    </template>
    <template #body="{ item }">
      <tr>
        <td>{{ browserDateTime(item.createdAt) }}</td>
        <td>{{ item.type.splitByUpperCase().join(' ') }}</td>
        <td>{{ item.reason }}</td>
        <td>{{ item.value }}</td>

        <td>{{ item.reviewedBy.email }}</td>
        <td>{{ item.reviewedAt }}</td>
        <td>{{ item.isApproved ? 'Approved' : 'Rejected' }}</td>
        <td>{{ item.reviewReason }}</td>
      </tr>
    </template>
  </DataTableAsync>
</template>

<script>
import DataTableAsync from '../common/dataTable/DataTableAsync.vue';

export default {
  components: { DataTableAsync, },
  props: ['items',],
  data() {
    return {
      tableState: { page: 1, perPage: 25 },
    };
  },
}
</script>